import DateFnsUtils from '@date-io/date-fns';
import {
  AppBar,
  Backdrop,
  Card, CardContent,
  CardHeader, CircularProgress,
  colors,
  createTheme,
  Divider, Grid,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ThemeProvider
} from '@material-ui/core';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { makeStyles } from '@material-ui/styles';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Chart from 'react-chartjs-2';
import DisplayField from 'src/components/DisplayField';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  container: {
    marginTop: theme.spacing(3)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: {
    marginTop: theme.spacing(3)
  },
  cardsMax: {
    maxHeight: 250,
    minHeight: 250
  },
  TableMax: {
    minHeight: 400,
    maxHeight: 400
  }
}));
const siyah = '#424242';
const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});

const localeMap = {
  tr: trLocale
};

const locale = localStorage.getItem('i18nextLng');


function Tamamlayici() {
  const classes = useStyles();
  const SessionUser = getUser();
  const [Loading, setLoading] = useState(true);
  const [tamamlayiciUrun, setTamamlayiciUrun] = useState([]);
  const [ciroGrafik, setCiroGrafik] = useState([]);
  const [Top5Ulke, setTop5Ulke] = useState([]);
  const [Top5Servis, setTop5Servis] = useState([]);
  const [Top5Bolge, setTop5Bolge] = useState([]);
  const [value, setValue] = React.useState('1');
  const [monthlyGrafik, setMonthlyGrafik] = useState([]);
  const [, setMonthlyCiro] = useState([]);
  const [labelsValue, setlabelsValue] = useState([]);
  const [labelsSPValue, setlabelsSPValue] = useState([]);
  const [valuesSP, setvaluesSP] = useState([]);

  useEffect(() => {
    let isMounted = true;

    axios
      .get(`/GetTeknisyenGunlukTamamlayiciUrun/${SessionUser.TechnicianId}`)
      .then(response => {
        if (isMounted) {
          const Response = (Array.isArray(response.data) && response.data.length > 0) 
            ? response.data[0] 
            : {};
          setTamamlayiciUrun(Response);
          setLoading(false)
        }
      }).catch(error => {
        if (isMounted) setLoading(false);
        logger.error("Hata detayı:", error.message);
      });

    return () => {
      isMounted = false;
    };
  }, [SessionUser.TechnicianId]);

  useEffect(() => {
    let isMounted = true;

    axios
      .get(`/GetTamamlayiciTop5/${SessionUser.TechnicianId}`)
      .then(response => {
        if (isMounted) {
          const Response = (Array.isArray(response.data) && response.data.length > 0) 
            ? response.data[0] 
            : {};
          setTop5Ulke(Array.isArray(Response?.UlkeSiralamasi) ? Response.UlkeSiralamasi : []);
          setTop5Bolge(Array.isArray(Response?.BölgeSiralamasi) ? Response.BölgeSiralamasi : []);
          setTop5Servis(Array.isArray(Response?.ServisSiralamasi) ? Response.ServisSiralamasi : []);
          setLoading(false);
        }
      }).catch(error => {
        if (isMounted) setLoading(false);
        logger.error("Hata detayı:", error.message);
      });

    return () => {
      isMounted = false;
    };
  }, [SessionUser.TechnicianId]);

  const changeCiro = React.useCallback(() => {
    var labels = []
    var values = []
    monthlyGrafik.forEach(i => {
      labels.push(i.SUM_CIRO);
      values.push(i.Ay);
      setlabelsValue(labels)
    })
  }, [monthlyGrafik]);

  const changeSP = React.useCallback(() => {
    var labelsSP = []
    var valuesSP = []
    ciroGrafik.forEach(i => {
      labelsSP.push(i.PG);
      valuesSP.push(i.Ciro);
      setlabelsSPValue(labelsSP)
      setvaluesSP(valuesSP)
    })
  }, [ciroGrafik]);

  const calculateperformance = React.useCallback((date) => {
    const options = { day: 'numeric', month: 'long' };
    let performancedate = moment(date).format('YYYY-MM-DD')
    axios
      .get(`/GetTeknisyen7GunlukTamamlayici/${SessionUser.TechnicianId}/${performancedate}/${1}`)
      .then(response => {
        const Response = response.data ? response.data : [];
        if (!Response) {
          [0, 1, 2, 3, 4, 5, 6].forEach(i => {
            var temp = moment(performancedate).subtract(i.toString(), 'days').format('YYYY-MM-DD')
            Response.push({
              "Ciro": 0, "MaxCiro": 400, "PG": temp
            })
          })
        } else {
          [0, 1, 2, 3, 4, 5, 6].forEach(i => {
            var temp = moment(performancedate).subtract(i.toString(), 'days').format('YYYY-MM-DD')
            if (Response.filter(i => i.PG === temp).length === 0) {
              Response.push({
                "PG": temp, "Ciro": 0
              })
            }
          }
          )
        }
        var sortCiroGrafik = Response?.sort((itemA, itemB) => new Date(itemA.PG) - new Date(itemB.PG));
        sortCiroGrafik.forEach((i, index) => {
          sortCiroGrafik[index].PG = new Date(sortCiroGrafik[index].PG).toLocaleDateString("tr-TR", options)
        })
        setCiroGrafik(sortCiroGrafik)
      }).catch(error => {
              logger.error("Hata detayı:", error.message);
      });
  }, [SessionUser.TechnicianId]);

  const calculateperformancemonthly = React.useCallback(() => {
    var numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    let performancedate = moment().format('YYYY-MM-DD')
    axios
      .get(`/GetTeknisyen7GunlukTamamlayici/${SessionUser.TechnicianId}/${performancedate}/${2}`)
      .then(response => {
        var Response = response.data ? response.data : [];
        if (!Response) {
          [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].forEach(i => {
            var temp = numbers[i]
            Response.push({
              "SUM_CIRO": 0, "Ay": temp
            })
          })
        } else {
          [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].forEach(i => {
            var temp = numbers[i]
            if (Response.filter(i => i.Ay === temp).length === 0) {
              Response.push({
                "SUM_CIRO": 0, "Ay": temp
              })
            }
          }
          )
        }
        var sortCiroMonthly = Response?.sort((itemA, itemB) => new Date(itemA.Ay) - new Date(itemB.Ay));
        setMonthlyGrafik(sortCiroMonthly)
        setMonthlyCiro(sortCiroMonthly.SUM_CIRO)
      }).catch(error => {
              logger.error("Hata detayı:", error.message);
      });
  }, [SessionUser.TechnicianId]);

  useEffect(() => {
    var yesterday = moment().add('-1', 'days').format('YYYY-MM-DD')
    calculateperformance(yesterday);
    calculateperformancemonthly();
  }, [SessionUser.TechnicianId, calculateperformance, calculateperformancemonthly]);

  useEffect(() => {
    if (!monthlyGrafik) {
      return;
    }
    changeCiro()
  }, [monthlyGrafik, changeCiro]);


  useEffect(() => {
    if (!ciroGrafik) {
      return;
    }
    changeSP()
  }, [ciroGrafik, changeSP]);

  var optionsbar = {
    scales: {
      y: {
        min: 0,
        max: ciroGrafik[0]?.MaxCiro,
        ticks: {
          // forces step size to be 50 units
          stepSize: 50
        }
      }
    }
  }

  const handleChangeStartDateSearch = e => {
    setStartDateSearch(e);
    calculateperformance(e);
  };

  const [StartDateSearch, setStartDateSearch] = useState(
    moment()
      .startOf('day')
      .add(-7, 'days')
      .add(12, 'hours')
      .format('YYYY-MM-DD')
  );
  const [minDate] = useState(
    moment()
      .startOf('day')
      .add(-45, 'days')
      .add(0, 'hours')
      .format('YYYY-MM-DD')
  );
  const [StartDate] = useState(
    moment()
      .startOf('day')
      .add(-1, 'days')
      .add(12, 'hours')
      .format('YYYY-MM-DD')
  );

  var data = {
    labels: labelsSPValue.slice(0, 12),
    datasets: [
      {
        type: 'line',
        label: ('Satıs Hedefi (TL)'),
        data: [tamamlayiciUrun?.Hedef, tamamlayiciUrun?.Hedef, tamamlayiciUrun?.Hedef, tamamlayiciUrun?.Hedef, tamamlayiciUrun?.Hedef, tamamlayiciUrun?.Hedef, tamamlayiciUrun?.Hedef],
        //tension: 0.3,
        backgroundColor: colors.blue[300],
        minBarLength: 10,
      },
      {
        label: ('Gerçek Ciro (TL)'),
        data: valuesSP.slice(0, 12),
        backgroundColor: colors.orange[300],
        minBarLength: 10,
      },
    ],
  };

  const months = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
  var aylikdata = {
    labels: months.slice(0, 12),
    datasets: [
      {
        label: ('Aylık Ciro (TL)'),
        data: labelsValue?.slice(0, 12),
        backgroundColor: colors.orange[300],
        minBarLength: 15,
      }
    ]
  }

  var optionsbar2 = {
    scales: {
      y: {
        min: 0,
        // Hedef undefined ise veya çarpım sonucu hatalıysa 100'e yuvarla
        max: (tamamlayiciUrun && tamamlayiciUrun.Hedef)
          ? Number(tamamlayiciUrun.Hedef * 30)
          : 100,
        ticks: {
          stepSize: 50,
          // Hata veren formatlamayı manuel override ederek düzeltiyoruz:
          callback: function (value) {
            // Sayıyı tam sayıya yuvarlayarak formatlama hatasını engelliyoruz
            return Math.round(value).toLocaleString('tr-TR');
          }
        }
      }
    },
    // Grafiğin taşmasını veya hatalı render edilmesini önlemek için:
    maintainAspectRatio: false,
    responsive: true
  };



  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (


    <Card>
      <CardHeader title="Tamamlayıcı Ürün"
        subheader="(Bir önceki gün yapılan toplam satış ve tutar adetidir.)" />
      <Divider />
      {
        Loading ?
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          : <div></div>
      }
      <Grid container spacing={1}>
        <Grid item xs={6} sm={6} lg={6}>
          <Card className={classes.cardsMax}>
            <CardHeader title="Günlük Değerler" />
            <Divider />
            <CardContent>
              <DisplayField
                label={('Satış Performansı')}
                value={
                  tamamlayiciUrun?.Ciro ? tamamlayiciUrun?.Ciro + ' TL' : '0 TL'
                }
              />
              <DisplayField
                label={('Satış Adeti')}
                value={tamamlayiciUrun?.Adet ? tamamlayiciUrun?.Adet : '0'}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={6} sm={6} lg={6}>
          <Card className={classes.cardsMax}>
            <CardHeader title="Günlük Sıralama" />
            <Divider />
            <CardContent>
              <DisplayField
                label={('Servis Sıralaması')}
                value={tamamlayiciUrun ? tamamlayiciUrun?.ServisSiralamasi + '. / ' + tamamlayiciUrun?.ServisTeknisyenleri : "-"}
              />
              <DisplayField
                label={('Bölge Sıralaması')}
                value={tamamlayiciUrun ? tamamlayiciUrun?.BolgeSiralamasi + '. / ' + tamamlayiciUrun?.BölgeTeknisyenleri : "-"}
              />
              <DisplayField
                label={('Türkiye Sıralaması')}
                value={tamamlayiciUrun ? tamamlayiciUrun?.UlkeSiralamasi + '. / ' + tamamlayiciUrun?.UlkeTeknisyenleri : "-"}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <Card >
            <Grid container spacing={1}>
              <div className={classes.root}>
                <TabContext value={value}>
                  <AppBar position="static" color="default">
                    <TabList onChange={handleChange} aria-label="simple tabs example">
                      <Tab label="Günlük Performans" value="1" />
                      <Tab label="Aylık Performans" value="2" />
                    </TabList>
                  </AppBar>
                  <TabPanel value="1">
                    <Grid item xs={12} sm={12} lg={12} alignItems='flex-end' >
                      <ThemeProvider theme={materialTheme} >
                        <MuiPickersUtilsProvider
                          utils={DateFnsUtils}
                          locale={localeMap[locale]}
                        >
                          <KeyboardDatePicker
                            color="primary"
                            margin="normal"
                            inputVariant="outlined"
                            id="BaslangicTarihi"
                            size="small"
                            label={('Başlangıç Tarihi')}
                            invalidDateMessage={('hatali_tarih')}
                            format="dd.MM.yyyy"
                            fullWidth
                            variant="outlined"
                            value={StartDateSearch}
                            maxDate={StartDate}
                            minDate={minDate}
                            onChange={e => handleChangeStartDateSearch(e)}
                            KeyboardButtonProps={{
                              'aria-label': 'change date'
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </ThemeProvider>
                    </Grid>
                    <Divider />
                    <Chart type={'bar'} options={optionsbar}
                      data={data} />
                  </TabPanel>
                  <TabPanel value="2">
                    <Chart type={'bar'} options={optionsbar2} data={aylikdata} />
                  </TabPanel>
                </TabContext>
              </div>
            </Grid>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <Card>
            <CardHeader title="Liderler Tablosu" />
            <CardContent >
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell align="left">{('Servis Sıralaması')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {[0, 1, 2, 3, 4].map(row => (
                      <TableRow key={row} >
                        <TableCell align="left">{(Array.isArray(Top5Servis) && Top5Servis[row]) ? Top5Servis[row].ServisSiralamasi : ''}</TableCell>
                        <TableCell align="left">{(Array.isArray(Top5Servis) && Top5Servis[row]) ? Top5Servis[row].AdSoyad : ''}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell align="left">{('Bölge Sıralaması')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {[0, 1, 2, 3, 4].map(row => (
                      <TableRow key={row} >
                        <TableCell align="left">{(Array.isArray(Top5Bolge) && Top5Bolge[row]) ? Top5Bolge[row].BolgeSiralamasi : ''}</TableCell>
                        <TableCell align="left">{(Array.isArray(Top5Bolge) && Top5Bolge[row]) ? Top5Bolge[row].AdSoyad : ''}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell align="left">{('Türkiye Sıralaması')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {[0, 1, 2, 3, 4].map(row => (
                      <TableRow key={row} >
                        <TableCell align="left">{(Array.isArray(Top5Ulke) && Top5Ulke[row]) ? Top5Ulke[row].UlkeSiralamasi : ''}</TableCell>
                        <TableCell align="left">{(Array.isArray(Top5Ulke) && Top5Ulke[row]) ? Top5Ulke[row].AdSoyad : ''}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Card>
  );
}

export default Tamamlayici;